import type { Colours } from '../../types'
import * as tokens from './generated-tokens/ts/colours'

export const colours: Colours = {
  white: tokens.SbColorWhite,
  black01: tokens.SbColorBlack01,
  black05: tokens.SbColorBlack05,
  black10: tokens.SbColorBlack10,
  black20: tokens.SbColorBlack20,
  black41: tokens.SbColorBlack41,
  black50: tokens.SbColorBlack50,
  black60: tokens.SbColorBlack60,
  black100: tokens.SbColorBlack100,
  charcoal: tokens.SbColorCharcoal100,
  lightGrey: tokens.SbColorLightGrey100,
  blue20: tokens.SbColorBlue20,
  blue50: tokens.SbColorBlue50,
  blue100: tokens.SbColorBlue100,
  purple20: tokens.SbColorPurple20,
  purple50: tokens.SbColorPurple50,
  purple100: tokens.SbColorPurple100,
  yellow20: tokens.SbColorYellow20,
  yellow50: tokens.SbColorYellow50,
  yellow100: tokens.SbColorYellow100,
  greenDark: tokens.SbColorGreenDark,
  green20: tokens.SbColorGreen20,
  green50: tokens.SbColorGreen50,
  green100: tokens.SbColorGreen100,
  pink20: tokens.SbColorPink20,
  pink50: tokens.SbColorPink50,
  pink100: tokens.SbColorPink100,
  indigo20: tokens.SbColorIndigo20,
  indigo50: tokens.SbColorIndigo50,
  indigo100: tokens.SbColorIndigo100,
  teal20: tokens.SbColorTeal20,
  teal50: tokens.SbColorTeal50,
  teal100: tokens.SbColorTeal100,
  gold20: tokens.SbColorGold20,
  gold50: tokens.SbColorGold50,
  gold100: tokens.SbColorGold100,
  cautionYellow: tokens.SbColorCautionYellow,
  errorRed: tokens.SbColorErrorRed,
  correctGreen: tokens.SbColorCorrectGreen,
  whichRed: tokens.SbColorWhichRed,
  interactiveBlue: tokens.SbColorInteractiveBlue,
  visitedPurple: tokens.SbColorVisitedPurple,
  brandYellow20: tokens.SbColorBrandYellow20,
  brandGold20: tokens.SbColorBrandGold20,
  brandPink20: tokens.SbColorBrandPink20,
  brandPurple20: tokens.SbColorBrandPurple20,
  brandBlue20: tokens.SbColorBrandBlue20,
  brandGreen20: tokens.SbColorBrandGreen20,
}
